import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Radar() {
  return (
    <PageLayout
      title="Radar Fraud Defense"
      subtitle="Enterprise-grade risk management powered by AI and vast network intelligence."
      badge="SECURITY SUITE"
      imageSrc="/products/art_radar_1776905097785.png"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-16">
        <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-sm hover:border-red-100 transition-colors">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 bg-red-50 text-red-600 rounded-xl flex items-center justify-center">
              <i className="ri-shield-keyhole-line text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900">Kount® Advanced</h3>
          </div>
          <p className="text-gray-600 mb-6">Utilize the industry's leading AI-driven fraud prevention tool. Real-time risk analysis blocks bad actors while reducing false positives, drastically increasing your sales conversion rates.</p>
        </div>
        
        <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-sm hover:border-blue-100 transition-colors">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center">
              <i className="ri-eye-line text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900">iSpyFraud™</h3>
          </div>
          <p className="text-gray-600 mb-6">A powerful, rule-based fraud prevention tool that gives you granular control. Set velocity limits, block specific IPs, and restrict high-risk countries before transactions ever hit the authorization network.</p>
        </div>
      </div>
    </PageLayout>
  );
}
